export enum PrivacyData {
  Private,
  Public,
}
